import { render } from "./SetupSpendingAnalysisPage.vue?vue&type=template&id=4da9c40e&scoped=true"
import script from "./SetupSpendingAnalysisPage.vue?vue&type=script&lang=js"
export * from "./SetupSpendingAnalysisPage.vue?vue&type=script&lang=js"

import "./SetupSpendingAnalysisPage.vue?vue&type=style&index=0&id=4da9c40e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4da9c40e"]])

export default __exports__